module.exports = __webpack_public_path__ + "img/ico_logout.962c79a1.svg";